/**
 * Record 편집 mutation 훅.
 *
 * 성공 시 해당 Job 상세 캐시를 무효화하여 테이블이 자동 재조회되도록 한다.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { editRecord, type EditRecordPayload } from "@/lib/api/records";
import { jobDetailKey } from "@/features/jobs/useJobDetail";
import type { RecordOut } from "@/lib/api/jobs";

interface Variables {
  jobId: string;
  fileId: string;
  payload: EditRecordPayload;
}

export function useEditRecord() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId, payload }) => editRecord(jobId, fileId, payload),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}
